"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var AutoGrowTextInput_1 = __importDefault(require("AutoGrowTextInput/AutoGrowTextInput"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var inversify_react_1 = require("inversify-react");
var mobx_react_1 = require("mobx-react");
var NumberInput_1 = __importDefault(require("NumberInput/NumberInput"));
var ItemQuantity_1 = require("Public/Widgets/QuoteV2/ItemQuantity");
var FakeNumberInput_1 = __importDefault(require("QuoteV2/Components/FakeNumberInput"));
var QuoteItemStore_1 = require("QuoteV2/Stores/QuoteItemStore");
var QuoteViewStore_1 = require("QuoteV2/Stores/QuoteViewStore");
var react_1 = __importDefault(require("react"));
var QuoteTelemetry_1 = require("Telemetry/QuoteTelemetry");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var ProductStaticWellKnownMapping_1 = require("@CommonFrontendBackend/QuoteV2/ProductStaticWellKnownMapping");
var c = (0, BemBuilder_1.default)("section");
var ItemQuantity = (function (_super) {
    __extends(ItemQuantity, _super);
    function ItemQuantity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemQuantity.prototype.render = function () {
        var _a;
        var _this = this;
        var _b;
        var _c = this.props, section = _c.section, item = _c.item, width = _c.width, _d = _c.syncQuantity, syncQuantity = _d === void 0 ? false : _d;
        var Input = (_a = {},
            _a[ItemQuantity_1.ItemQuantityWidth.Fixed] = kaleidoscope_1.TextInput,
            _a[ItemQuantity_1.ItemQuantityWidth.Dynamic] = AutoGrowTextInput_1.default,
            _a)[width];
        if (item instanceof QuoteItemStore_1.QuoteFixedCostItemStore || item instanceof QuoteItemStore_1.QuoteVariableItemStore) {
            var stepperProps = item.isQuantityOptional
                ? {
                    showStepper: true,
                    min: item.quantityOptionalMin,
                    max: item.quantityOptionalMax,
                }
                : {};
            return (react_1.default.createElement("div", { className: c("quantity") },
                react_1.default.createElement(NumberInput_1.default, __assign({ autogrow: true, label: "Quantity", labelHidden: true, variant: item.isQuantityOptional ? kaleidoscope_1.TextInputVariant.Underlined : kaleidoscope_1.TextInputVariant.Borderless, size: kaleidoscope_1.TextInputSize.Small, value: item.quantity, onChange: function (value) {
                        var e_1, _a;
                        item.quantity = value;
                        if (syncQuantity && item.isQuantityOptional) {
                            try {
                                for (var _b = __values(section.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                                    var sectionItem = _c.value;
                                    if (sectionItem !== item &&
                                        sectionItem instanceof QuoteItemStore_1.QuotePricedItemStore &&
                                        sectionItem.isQuantityOptional &&
                                        sectionItem.unit === item.unit) {
                                        sectionItem.quantity = value;
                                    }
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        }
                        _this.quoteTelemetry.trackLineItemQuantityChanged(section.displayMode);
                    } }, stepperProps)),
                item instanceof QuoteItemStore_1.QuoteFixedCostItemStore && (react_1.default.createElement(Input, { label: "Unit", labelHidden: true, variant: kaleidoscope_1.TextInputVariant.Borderless, size: kaleidoscope_1.TextInputSize.Small, elementSize: 1, value: item.unit, onChange: function (value) {
                        item.unit = value;
                    } })),
                item instanceof QuoteItemStore_1.QuoteVariableItemStore && react_1.default.createElement("span", { className: c("unit", "static") }, item.unit)));
        }
        if (item instanceof QuoteItemStore_1.QuoteProductItemStore) {
            return (react_1.default.createElement("div", { className: c("quantity") },
                react_1.default.createElement(FakeNumberInput_1.default, { editable: item.isQuantityOptional },
                    react_1.default.createElement(kaleidoscope_1.Tooltip, { content: "The product quantity specified in the CRM", size: kaleidoscope_1.TooltipSize.Large },
                        react_1.default.createElement("div", null, "p.".concat(ProductStaticWellKnownMapping_1.ProductStaticWellKnownMapping.getMappedProductFieldName(Types_1.ProductMappedField.Quantity, (_b = item.token.substitutionToken) === null || _b === void 0 ? void 0 : _b.id)))))));
        }
        return null;
    };
    var _a, _b;
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_a = typeof QuoteTelemetry_1.QuoteTelemetry !== "undefined" && QuoteTelemetry_1.QuoteTelemetry) === "function" ? _a : Object)
    ], ItemQuantity.prototype, "quoteTelemetry", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(QuoteViewStore_1.QuoteViewStore.$),
        __metadata("design:type", typeof (_b = typeof QuoteViewStore_1.QuoteViewStore !== "undefined" && QuoteViewStore_1.QuoteViewStore) === "function" ? _b : Object)
    ], ItemQuantity.prototype, "quoteViewStore", void 0);
    ItemQuantity = __decorate([
        mobx_react_1.observer
    ], ItemQuantity);
    return ItemQuantity;
}(react_1.default.Component));
exports.default = ItemQuantity;
